<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="myExtraLargeModalLabel">
      <ng-container>
        <h3>ALTRON TMT (Pty) Ltd - Delivery note</h3>
      </ng-container>
    </h4>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body" id="content" #content>
    <div class="row form-horizontal">
      <div class="col-md-12 form-horizontal">

        <br />
        <div class="form-group row" style="padding: 10px 10px 30px 50px;">
          <table width="95%" style="text-align:left">

            <tr class="row">
              <td colspan="4" style="text-align:right">
                <img src="../../../assets/images/altron_fintech_logo.png" height="80" alt="logo" />
                <br /><br />

              </td>
            </tr>

            <tr class="row"></tr>

            <tr class="row">
              <td class="col-3" style="border: 1px solid gray; background-color: silver; color: black; width:25%;">
                <label for="Waybill" class="col-form-label">&nbsp;Waybill</label>
              </td>
              <td class="col-3" style="border: 1px solid gray; background-color: silver; color: black; width: 25%;">
                <label for="Waybill" class="col-form-label">&nbsp;Customer name</label>
              </td>
              <td class="col-3" style="border: 1px solid gray; background-color: silver; color: black; width: 25%;">
                <label for="Waybill" class="col-form-label">&nbsp;Merchant Name</label>
              </td>
              <td class="col-3" style="border: 1px solid gray; background-color: silver; color: black; width: 25%;">
                <label for="Waybill" class="col-form-label">&nbsp;Created date </label>
              </td>
            </tr>
            <tr class="form-group row">
              <td class="col-3" style="border:1px solid gray">
                <label class="col-form-label">&nbsp;{{Waybill}}</label>
              </td>
              <td class="col-3" style="border:1px solid gray">
                <label class="col-form-label">&nbsp;{{CustomerName}}</label>
              </td>
              <td class="col-3" style="border:1px solid gray">
                <label class="col-form-label">&nbsp;{{MerchantName}}</label>
              </td>
              <td class="col-3" style="border:1px solid gray">
                <label class="col-form-label">&nbsp;{{CreatedDate}}</label>
              </td>
            </tr>

            <tr class="form-group row">
            </tr>


            <tr class="row">
              <td class="col-6" colspan="2" style="border:1px solid gray; border-right:0px solid white; background-color:silver; color:black">
                <h5 class="col-form-label">&nbsp;Terminal details</h5>
              </td>
              <td class="col-6" colspan="2" style="border: 1px solid gray; background-color: silver; color: black">
                <h5 class="col-form-label">&nbsp;Delivery details</h5>
              </td>
            </tr>

            <tr class="row">
              <td class="col-3" style="border-left: 1px solid silver;">
                <label class="col-form-label" style="">&nbsp;<b>Ticket No:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                &nbsp;
                <input class="" id="fcTicketNr" (input)="updateTicketNr($event.target.value)" placeholder="" style="width: 100%; border: 1px solid #ccc; border-radius: 0.25rem; padding: 0.65rem; " />
                {{TicketNo}}
              </td>
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Merchant name:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{MerchantName}}</label>
              </td>
            </tr>
            <tr class="row">
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Merchant No:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{merchantId}}</label>
              </td>
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Contact details:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{ContactDetails}}</label>
              </td>
            </tr>
            <tr class="row">
              <td class="col-6" rowspan="5" colspan="2" style="border-left: 1px solid silver; border-right: 1px solid silver;">
                <table width="100%" *ngFor="let terminal of terminalsSignUp" style="border: 1px solid silver">
                  <tr>
                    <td style="width: 51%"><label class="col-form-label">&nbsp;<b>Terminal Id:</b></label></td>
                    <td style="width: 49%"><label class="col-form-label">&nbsp;{{terminal.terminalId}}</label></td>
                  </tr>
                  <tr>
                    <td style="width: 51%"><label class="col-form-label">&nbsp;<b>Serial Number:</b></label></td>
                    <td style="width: 49%"><label class="col-form-label">&nbsp;{{terminal.serialNumber}}</label></td>
                  </tr>
                  <tr>
                    <td style="width: 51%"><label class="col-form-label">&nbsp;<b>Base serial number:</b></label></td>
                    <td style="width: 49%"><label class="col-form-label">&nbsp;{{terminal.baseSerialNumber}}</label></td>
                  </tr>
                  <tr>
                    <td style="width: 51%"><label class="col-form-label">&nbsp;<b>Sim Number:</b></label></td>
                    <td style="width: 49%"><label class="col-form-label">&nbsp;{{terminal.simNumber}}</label></td>
                  </tr>
                  <tr>
                    <td style="width: 51%">
                      <label class="col-form-label">&nbsp;<b>Make:</b></label>
                    </td>
                    <td style="width: 49%">
                      <label class="col-form-label">&nbsp;{{GetDeviceMake(terminal.make)}}</label>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:51%">
                      <label class="col-form-label">&nbsp;<b>Model:</b></label>
                    </td>
                    <td style="width:49%">
                      <label class="col-form-label">&nbsp;{{GetDeviceModel(terminal.model)}}</label>
                    </td>
                  </tr>

                  <tr>
                    <td style="width:51%; vertical-align:top;">
                      <label class="col-form-label"><b>Retail:</b></label>
                    </td>
                    <td style="width:49%; vertical-align:top;">
                      <label class="col-form-label">{{terminal.retail}}</label>
                    </td>
                  </tr>

                  <tr>
                    <td style="width:51%; vertical-align:top;">
                      <label class="col-form-label"><b>Admin:</b></label>
                    </td>
                    <td style="width:49%; vertical-align:top;">
                      <label class="col-form-label">{{terminal.admin}}</label>
                    </td>
                  </tr>
                </table>
              </td>

              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Delivery address:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{DeliveryAddress}}</label>
              </td>
            </tr>
            <tr class="row">
              <!--<td class="col-3" style="border-left:1px solid silver;">
      <label class="col-form-label">&nbsp;</label>
    </td>
    <td class="col-3" style="border-right:1px solid silver;">
      <label class="col-form-label">&nbsp;</label>
    </td>-->
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>City:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{City}}</label>
              </td>
            </tr>
            <tr class="row">
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Town:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{Town}}</label>
              </td>
            </tr>
            <tr class="row">
              <!--<td class="col-3" style="border-left:1px solid silver;">
      <label class="col-form-label">&nbsp;</label>
    </td>
    <td class="col-3" style="border-right:1px solid silver;">
      <label class="col-form-label">&nbsp;</label>
    </td>-->
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Region:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{Region}}</label>
              </td>
            </tr>
            <tr class="row">

              <!--<td class="col-3" style="border-left: 1px solid silver; border-bottom: 1px solid Silver">
      <label class="col-form-label"></label>
    </td>
    <td class="col-3" style="border-right: 1px solid silver; border-bottom: 1px solid Silver">
      <label class="col-form-label"></label>
    </td>-->
              <td class="col-3" style="border-left: 1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Country:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{Country}}</label>
              </td>
            </tr>
            <tr class="row">

              <!--<td class="col-3" style="border-left: 1px solid silver; border-bottom: 1px solid Silver">
      <label class="col-form-label"></label>
    </td>
    <td class="col-3" style="border-right: 1px solid silver; border-bottom: 1px solid Silver">
      <label class="col-form-label"></label>
    </td>-->
              <td class="col-3" style="border-left: 1px solid silver; border-bottom: 1px solid Silver">
                <label class="col-form-label">&nbsp;<b>Delivery method:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver; border-bottom:1px solid Silver">
                <label class="col-form-label">&nbsp;{{DeliveryMethod}}</label>
              </td>
            </tr>

            <tr class="form-group row">
            </tr>

            <tr class="row">
              <td class="col-6" colspan="2" style="border:1px solid gray; border-right:0px solid white; background-color:silver; color:black">
                <h5 class="col-form-label">&nbsp;Checklist</h5>
              </td>
              <td class="col-6" colspan="2" style="border: 1px solid gray; background-color: silver; color: black">
                <h5 class="col-form-label">&nbsp;Application details</h5>
              </td>
            </tr>

            <tr class="row">
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Parameter download:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                &nbsp;<ng-select2 id="fcParameterDownload" [data]="deviceCheckList" [options]="select2options" [placeholder]="'Please select...'" (valueChanged)="updateParameterDownload($event)"></ng-select2>
                {{ParameterDownload}}
              </td>
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>App name:</b></label>
              </td>
              <td class="col-3 col-form-label" style="border-right:1px solid silver;">
                &nbsp;<input class="" id="fcAppName" (input)="updateAppName($event.target.value)" placeholder="" style="width: 100%; border: 1px solid #ccc; border-radius: 0.25rem; padding: 0.65rem; ">
                {{AppName}}
              </td>
            </tr>

            <tr class="row">
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Keys:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                &nbsp;<ng-select2 id="fcKeys" [data]="deviceCheckList" [options]="select2options" [placeholder]="'Please select...'" (valueChanged)="updateKeys($event)"></ng-select2>
                {{Keys}}
              </td>
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>App/ software version:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                &nbsp;<input class="" id="fcSoftwareVersion" (input)="updateSoftwareVersion($event.target.value)" placeholder="" style="width: 100%; border: 1px solid #ccc; border-radius: 0.25rem; padding: 0.65rem; ">
                {{SoftwareVersion}}
              </td>
            </tr>

            <tr class="row">
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Power supply:</b></label>
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                &nbsp;<ng-select2 id="fcPowerSupply" [data]="deviceCheckList" [options]="select2options" [placeholder]="'Please select...'" (valueChanged)="updateDevicePowerSupply($event)"></ng-select2>
                {{PowerSupply}}
              </td>
              <td class="col-3" style="border-left:1px solid silver;">
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
              </td>
            </tr>
            <tr class="row">
              <td class="col-3" style="border-left: 1px solid silver; border-bottom: 1px solid Silver;">
                <label class="col-form-label">&nbsp;<b>Battery:</b></label>
              </td>
              <td class="col-3" style="border-right: 1px solid silver; border-bottom: 1px solid Silver;">
                &nbsp;<ng-select2 id="fcBattery" [data]="deviceCheckList" [options]="select2options" [placeholder]="'Please select...'" (valueChanged)="updateDeviceBattery($event)"></ng-select2>
                {{Battery}}
              </td>
              <td class="col-3" style="border-left: 1px solid silver; border-bottom: 1px solid Silver;">
              </td>
              <td class="col-3" style="border-right: 1px solid silver; border-bottom: 1px solid Silver;">
              </td>
            </tr>

            <tr class="form-group row">
            </tr>

            <tr class="row">
              <td class="col-3" style="border-left:1px solid silver; border-top:1px solid gray">
                <label class="col-form-label">&nbsp;<b>Receiver Name:</b></label><br /><br />
              </td>
              <td class="col-3" style="border-right: 1px solid silver; border-top: 1px solid gray">
                <label class="col-form-label">&nbsp;</label><br /><br />
              </td>
              <td class="col-3" style="border-left: 1px solid silver; border-top: 1px solid gray">
                <label class="col-form-label">&nbsp;<b>Driver Name:</b></label><br /><br />
              </td>
              <td class="col-3" style="border-right: 1px solid silver; border-top: 1px solid gray">
                <label class="col-form-label">&nbsp;{{DriverName}}</label><br /><br />
              </td>
            </tr>

            <tr class="row">
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Date:</b></label>
                <br /><br />
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{CustomerDate}}</label>
                <br /><br />
              </td>
              <td class="col-3" style="border-left:1px solid silver;">
                <label class="col-form-label">&nbsp;<b>Date:</b></label>
                <br /><br />
              </td>
              <td class="col-3" style="border-right:1px solid silver;">
                <label class="col-form-label">&nbsp;{{DriverDate}}</label>
                <br /><br />
              </td>
            </tr>

            <tr class="row">
              <td class="col-3" style="border-left: 1px solid silver; border-bottom: 1px solid Silver;">
                <label class="col-form-label">&nbsp;<b>Customer Signature:</b></label>
                <br /><br />
              </td>
              <td class="col-3" style="border-right: 1px solid silver; border-bottom: 1px solid Silver;">
                <label class="col-form-label">&nbsp;</label>
                <br /><br />
              </td>
              <td class="col-3" style="border-left: 1px solid silver; border-bottom: 1px solid Silver;">
                <label class="col-form-label">&nbsp;<b>Driver Signature:</b></label>
                <br /><br />
              </td>
              <td class="col-3" style="border-right: 1px solid silver; border-bottom: 1px solid Silver;">
                <label class="col-form-label">&nbsp;</label><br /><br />
              </td>
            </tr>

            <tr class="form-group row">
            </tr>

            <tr class="form-group row" *ngIf="isCourier">
              <td class="col-6" colspan="2">
                <br />
                <img id="imgBarCode" [src]="" alt="BarCode" />

              </td>
              <td class="col-6" colspan="2">
                <br />
                <img id="imgQRCode" [src]="" alt="GR Code" style="border: 1px solid gray; " />

              </td>
            </tr>





            <tr class="form-group row">
              <td class="col-12" colspan="4">
                <button type="button"
                        class="btn btn-success"
                        (click)="print()">
                  Print
                </button>
                &nbsp;
                <button type="button"
                        class="btn btn-primary"
                        (click)="close()">
                  Close
                </button>

              </td>
            </tr>
          </table>

          

        </div>
      </div>

    </div>
  </div>
</div>
